// extracted by mini-css-extract-plugin
export default {"replyActive":"Comments_replyActive__CBUEs"};